import React, { useState, useEffect, useRef } from "react";
import { Camera, Eye, EyeOff } from "lucide-react";
import axios from "axios";
import { BaseUrl } from "../App";

// import { Circles } from "react-loader-spinner";

import { FadeLoader } from "react-spinners";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar as fullStar,
  faStarHalfAlt,
  faStar as emptyStar,
} from "@fortawesome/free-solid-svg-icons";

function StaffProfile() {
  const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [selectedStaffId, setSelectedStaffId] = useState(null);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const servicesDropdownRef = useRef(null);
  const [staffData, setStaffData] = useState([]); // To store staff data
  const [selectedServices, setSelectedServices] = useState([]); // To store selected services
  console.log(selectedServices);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false); // To toggle dropdown visibility
  const [isServicesLoading, setIsServicesLoading] = useState(true);
  const [services, setServices] = useState([]);
  console.log("Services state:", services); // Debugging line
  const [rating, setRating] = useState(0); // Initialize rating state
  console.log("Rating state:", rating); // Debugging line
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    description: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    profileImage: null,
    enableBooking: false,
    rating: "",
    password: "",
  });
  const [staffMembers, setStaffMembers] = useState([]);

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleToggle = () => {
    setFormData((prevData) => ({
      ...prevData,
      enableBooking: prevData.enableBooking === "Y" ? "N" : "Y", // Toggle correctly
    }));
  };

  const handleServiceSelect = (service) => {
    setSelectedServices((prev) => {
      const isSelected = prev.some((s) => Number(s.id) === Number(service.id));
      console.log("Is Selected:", isSelected, "Service ID:", service.id);
      const updated = isSelected
        ? prev.filter((s) => Number(s.id) !== Number(service.id))
        : [...prev, service];
      console.log("Updated selectedServices:", updated);
      return updated;
    });
    console.log("Dropdown state after selection:", showServicesDropdown); // Should still be true
  };
  // New function to handle service removal
  const handleServiceRemove = (serviceId) => {
    setSelectedServices((prev) => {
      const updatedServices = prev.filter(
        (service) => service.id !== serviceId
      );
      console.log("After removal, selectedServices:", updatedServices);
      return updatedServices;
    });
  };

  const fetchAllServices = async () => {
    try {
      setIsServicesLoading(true);
      const response = await axios.post(`${BaseUrl}/backend/api/services.php`, {
        action: "get_all_services",
        api_key: "1",
      });
      if (response.data.status === "true") {
        console.log("Services fetched:", response.data.response);
        setServices(response.data.response || []);
      } else {
        console.error("Failed to fetch services:", response.data.response);
        setServices([]);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setServices([]);
    } finally {
      setIsServicesLoading(false);
    }
  };

  useEffect(() => {
    if (services.length === 0) {
      fetchAllServices();
    } // Fetch services on component mount
  }, []);

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({ ...prev, profileImage: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChangePasswordClick = () => {
    setIsChangePasswordVisible(!isChangePasswordVisible);
  };

  // useEffect(() => {
  //   const userId = sessionStorage.getItem("userId");
  //   console.log("Retrieved userId from localStorage: ", userId);
  //   if (userId) {
  //     // fetchStaffData(userId);
  //     setSelectedStaffId(userId);
  //     fetchStaffDetails(userId); // Fetch staff details using the userId
  //   } else {
  //     console.log("No user ID found, handle accordingly");
  //     setLoading(false);
  //   }
  // }, []);
  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    console.log("Retrieved userId from localStorage: ", userId);
    if (userId && services.length > 0) {
      // Only fetch staff details when services are available
      setSelectedStaffId(userId);
      fetchStaffDetails(userId);
      fetchStaffDetailsdata(userId); // Fetch staff details using the userId
    }
  }, [services]);
  console.log("Available services:", services);

  const fetchStaffDetailsdata = async (staffId) => {
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/services.php`, {
        action: "get_rating_review",
        staff_id: staffId,
      });
      console.log(response.data);

      if (response.data.status === "true") {
        setStaffData(response.data.data); // Set data to state
        console.log("Staff Review Data:", response.data.data);
      } else {
        console.warn("No data:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching staff details:", error);
    }
  };

  const renderRatingStars = (rating) => {
    return (
      <div className="flex items-center space-x-1">
        {[1, 2, 3, 4, 5].map((star) => {
          const isFilled = star <= Math.floor(rating);
          const isHalfFilled =
            star === Math.floor(rating) + 1 && rating % 1 !== 0;
          return (
            <span key={star} className="text-lg text-yellow-500">
              {isFilled ? (
                <FontAwesomeIcon icon={fullStar} />
              ) : isHalfFilled ? (
                <FontAwesomeIcon icon={faStarHalfAlt} />
              ) : (
                <FontAwesomeIcon icon={emptyStar} className="text-gray-300" />
              )}
            </span>
          );
        })}
      </div>
    );
  };

  const fetchStaffDetails = async (id) => {
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/staff.php`, {
        action: "get_staff_details",
        api_key: "1",
        id,
      });

      console.log(response.data);
      if (response.data.status === "true") {
        const details = response.data.response;
        console.log(details);
        setFormData({
          name: details.fullname,
          email: details.email,
          description: details.description,
          phone: details.phone,
          address: details.address,
          city: details.city,
          state: details.state,
          zip: details.zip,
          country: details.country,
          profileImage: details.image,
          enableBooking: details.enable_booking,
          ct_service_staff: details.service_ids,
        });
        console.log(details.service_ids);
        console.log("Available services:", services);

        // Handle assigned services
        if (details.service_ids) {
          const serviceIds = details.service_ids.split(",").map(Number); // Convert "1,2,4" to [1, 2, 4]
          console.log("Service IDs:", serviceIds);
          console.log("Available services:", services);

          const assignedServices = services.filter((service) =>
            serviceIds.includes(Number(service.id))
          );
          console.log("Assigned services:", assignedServices);
          setSelectedServices(assignedServices);
        } else {
          setSelectedServices([]);
        }
      }
    } catch (error) {
      console.error("Error fetching staff details:", error);
    }
  };

  const validateForm = () => {
    const errors = {};

    // Email validation
    if (!validateEmail(formData.email)) {
      errors.email = "Please enter a valid email address";
    }

    // Phone validation (10 digits)
    if (!/^\d{10}$/.test(formData.phone)) {
      errors.phone = "Phone number must be exactly 10 digits";
    }

    // Zip code validation (6 digits)
    if (formData.zip && !/^\d{6}$/.test(formData.zip)) {
      errors.zip = "Zip code must be exactly 6 digits";
    }

    // Password validation
    if (isChangePasswordVisible) {
      if (newPassword !== confirmPassword) {
        errors.confirmPassword = "Passwords do not match";
      }
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleUpdatePassword = async () => {
    if (newPassword !== confirmPassword) {
      setValidationErrors({
        ...validationErrors,
        confirmPassword: "Passwords do not match",
      });
      return;
    }

    // Add password update logic here
    setSuccessMessage("Password updated successfully");
    setIsChangePasswordVisible(false);
  };

  // const handleSubmit = async (e) => {
  //   setLoading(true);
  //   e.preventDefault();

  //   if (!validateForm()) {
  //     return;
  //   }

  //   const userId = sessionStorage.getItem('userId');
  //   if (!userId) {
  //     setError('User ID is missing. Please log in again.');
  //     return;
  //   }

  //   try {
  //     const response = await axios.post(`${BaseUrl}/backend/api/profile_data_update.php`, {
  //       action: "profile_detail_update",
  //       api_key: "1",
  //       user_id: userId,
  //       type: "staff",
  //       fullname: formData.name,
  //       email: formData.email,
  //       phone: formData.phone,
  //       address: formData.address,
  //       city: formData.city,
  //       state: formData.state,
  //       zip: formData.zip,
  //       country: formData.country,
  //       description: formData.description,
  //       password: formData.password,  // ✅ Password added
  //       enable_booking: formData.enableBooking,
  //     });

  //     console.log('API response:', response.data.response);

  //     if (response.data.status === 'true') {
  //       setSuccessMessage("Staff Profile Detail Updated Successfully");
  //       window.scrollTo(0, 0);
  //     } else {
  //       setError(response.data.response);
  //     }
  //   } catch (error) {
  //     console.error('Error updating user profile:', error);
  //     setError('Something went wrong. Please try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // if (loading) {
  //   return (
  //     <div className="flex justify-center items-center h-screen">
  //       <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  //     </div>
  //   );
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      setError("User ID is missing. Please log in again.");
      return;
    }

    // Prepare the array of service IDs
    const serviceIds = selectedServices.map((service) => Number(service.id)); // Ensure IDs are numbers
    console.log("Selected services:", serviceIds); // Debugging line

    const updatedData = {
      action: "update_staff",
      api_key: "1",
      id: userId,
      fullname: formData.name,
      email: formData.email,
      description: formData.description,
      phone: formData.phone,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      country: formData.country,
      enable_booking: formData.enableBooking === "Y" ? "Y" : "N",
      ct_service_staff: serviceIds, // Pass as array [1, 2, 4]
      image: formData.profileImage || "",
      pass: formData.password || "", // Include password if it exists
    };

    try {
      console.log("Payload being sent:", updatedData); // Debug payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/staff.php`,
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("API Response:", response.data); // Debug response

      if (response.data.status === "true") {
        setSuccessMessage("Staff Details Updated Successfully!");
        setStaffMembers((prevStaff) =>
          prevStaff.map((staff) =>
            staff.id === selectedStaffId
              ? { ...staff, ...response.data.response }
              : staff
          )
        );
      } else {
        setError("Failed to update staff details: " + response.data.response);
      }
    } catch (error) {
      console.error("Error updating staff details:", error);
      setError(
        "An error occurred while updating staff details: " + error.message
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="relative min-h-screen">
      {/* Loading Indicator */}
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
            <FadeLoader
              height={15}
              width={5}
              color="#ffffff"
              ariaLabel="loading"
            />
            <h1 className="mt-1 text-lg text-white">Please wait...</h1>
          </div>
        </div>
      )}

      <div className="container mx-auto p-4 bg-gray-50 min-h-screen">
        {successMessage && (
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded shadow-md mb-6 animate-fadeIn">
            <div className="flex">
              <div className="py-1">
                <svg
                  className="w-6 h-6 mr-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <span className="font-medium">{successMessage}</span>
            </div>
          </div>
        )}

        {error && (
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded shadow-md mb-6">
            <div className="flex">
              <div className="py-1">
                <svg
                  className="w-6 h-6 mr-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>
              <span className="font-medium">{error}</span>
            </div>
          </div>
        )}
        <div className="flex-1 flex items-center justify-center px-2 sm:px-6">
          {" "}
          {/* Less padding for mobile */}
          <div className="w-full max-w-md sm:max-w-4xl">
            {" "}
            {/* More width on mobile */}
            <div className="mb-6 sm:mb-8 text-center">
              <h1 className="text-2xl sm:text-4xl font-bold text-gray-800">
                {formData.name || "Staff Members"}
              </h1>
            </div>
            {/* Form Section */}
            <form
              onSubmit={handleSubmit}
              className="bg-white shadow-xl rounded-xl p-4 sm:p-8 w-full transition-transform hover:scale-[1.01]"
            >
              {/* Profile Image */}
              <div className="mb-6 sm:mb-8 flex justify-center">
                <div className="relative">
                  <div
                    className="w-20 h-20 sm:w-28 sm:h-28 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden border-4 border-white shadow-lg"
                    style={{
                      backgroundImage: formData.profileImage
                        ? `url(${formData.profileImage})`
                        : "none",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    {!formData.profileImage && (
                      <Camera className="w-8 sm:w-10 h-8 sm:h-10 text-gray-400" />
                    )}
                  </div>
                  <input
                    type="file"
                    id="profileImage"
                    onChange={handleProfileImageChange}
                    className="hidden"
                    accept="image/*"
                  />
                  <label
                    htmlFor="profileImage"
                    className="absolute bottom-0 right-0 bg-blue-500 hover:bg-blue-600 rounded-full p-1 sm:p-2 cursor-pointer shadow-md transition-colors"
                  >
                    <Camera className="w-3 sm:w-4 h-3 sm:h-4 text-white" />
                  </label>
                </div>
              </div>

              <div className="space-y-4 sm:space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 cursor-[url('/red-cursor.png'),_auto]">
                    Name
                  </label>

                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    disabled
                    className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-900 cursor-not-allowed"
                    placeholder="Enter staff name"
                  />
                  <p className="text-sm font-bold  text-red-500 mt-1">
                    *Do Not Change Name Second Time
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                    placeholder="Enter email address"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Description
                  </label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    rows="3"
                    className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                  ></textarea>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Phone
                  </label>
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                    placeholder="Enter phone number"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Address
                  </label>
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                    placeholder="Enter address"
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      City
                    </label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      State
                    </label>
                    <input
                      type="text"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Zip
                    </label>
                    <input
                      type="text"
                      name="zip"
                      value={formData.zip}
                      onChange={handleChange}
                      className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Country
                    </label>
                    <input
                      type="text"
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                    />
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0   bg-gray-50 rounded-md">
                  <p className="text-sm font-semibold text-gray-700 sm:w-1/3">
                    User Rating:
                  </p>
                  <div className="flex items-center">
                    {/* Check if staffData has content */}
                    {staffData.length > 0 ? (
                      <>
                        {/* Render stars dynamically based on the rating */}
                        {staffData.map((item) =>
                          renderRatingStars(item?.rating)
                        )}

                        {/* Display the rating value in a box next to the stars */}
                        <div className="ml-4 p-2 border border-gray-300 rounded bg-gray-50 text-sm font-medium">
                          {staffData.map((item) => item?.rating)}
                        </div>
                      </>
                    ) : (
                      // Show 'No reviews' if staffData is empty
                      <span className="text-gray-500">No reviews</span>
                    )}
                  </div>
                </div>

                <div className="flex items-center justify-between bg-gray-50 p-3 sm:p-4 rounded-lg">
                  <span className="text-sm font-medium text-gray-700">
                    Enable Booking
                  </span>
                  <button
                    type="button"
                    onClick={handleToggle}
                    className={`w-10 sm:w-12 h-5 sm:h-6 rounded-full p-1 transition-colors duration-200 ${
                      formData.enableBooking === "Y"
                        ? "bg-green-500"
                        : "bg-red-500"
                    }`}
                  >
                    <div
                      className={`w-3 sm:w-4 h-3 sm:h-4 bg-white rounded-full transform transition-transform duration-200 ${
                        formData.enableBooking === "Y"
                          ? "translate-x-5 sm:translate-x-6"
                          : "translate-x-0"
                      }`}
                    />
                  </button>
                </div>
                <div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Services <span className="text-red-500">*</span>
                    </label>
                    <div className="relative" ref={servicesDropdownRef}>
                      <div
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
                        onClick={() => {
                          console.log(
                            "Parent clicked, toggling dropdown. Current state:",
                            showServicesDropdown
                          );
                          setShowServicesDropdown((prev) => {
                            console.log("New dropdown state:", !prev);
                            return !prev;
                          });
                        }}
                      >
                        <div className="flex flex-wrap gap-2 min-h-[24px]">
                          {selectedServices.length > 0 ? (
                            selectedServices.map((service) => (
                              <div
                                key={service.id}
                                className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md flex items-center gap-1"
                              >
                                <span>{service.title}</span>
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleServiceRemove(service.id);
                                  }}
                                  className="text-blue-800 hover:text-blue-900"
                                >
                                  ×
                                </button>
                              </div>
                            ))
                          ) : (
                            <span className="text-gray-500">
                              Select services
                            </span>
                          )}
                        </div>
                      </div>
                      {showServicesDropdown && (
                        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                          {isServicesLoading ? (
                            <div className="p-2 text-gray-500">
                              Loading services...
                            </div>
                          ) : services.length > 0 ? (
                            services.map((service) => (
                              <div
                                key={service.id}
                                className={`p-2 cursor-pointer hover:bg-gray-100 ${
                                  selectedServices.some(
                                    (s) => Number(s.id) === Number(service.id)
                                  )
                                    ? "bg-blue-100 text-blue-800"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  console.log(
                                    "Service item clicked:",
                                    service.id
                                  );
                                  handleServiceSelect(service);
                                }}
                              >
                                {service.title}
                              </div>
                            ))
                          ) : (
                            <div className="p-2 text-gray-500">
                              No services available
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 sm:py-3 px-4 rounded-lg font-medium shadow-md transition-colors"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StaffProfile;
